module.exports = __webpack_public_path__ + "static/boids-3faa93ffce35ab682f64305d2f1ddf82.gif";